import { PlainFilterSet } from 'src/app/shared/models/Filter';

import lodash from 'lodash';

export const valWithChecked = (checked: boolean,
  value: any,
  defaultValue = '') => {
  return (checked && value) || defaultValue;
};

export const buildQueryFromFilters = (filters: PlainFilterSet) => {
  const query = {};

  Object.entries<any>(filters).forEach(([key, value]) => {
    if (!value.enabled) {
      return;
    }

    const defaultValue = lodash.has(value, 'defaultValue') ?
      value.defaultValue :
      '';

    // The redundant check for enabled is to maintain consistency
    // and clear dependency of both the methods.
    query[key] = valWithChecked(
      value.enabled,
      value.value,
      defaultValue,
    );
  });

  return query;
};
